import { useStrings } from "@1js/localization-components";
import { Tab, Text } from "@fluentui/react-components";
import React from "react";
import type { Appearance } from "../data";
import { WorkplaceLabel } from "./PromptTab.strings";
import { PromptTabs } from "./PromptTabs";
import { useStyles } from "./Tab.styles";

export const WorkplaceTabTestId = "workplace-prompts-tab";

type Props = {
  isSelected: boolean;
  appearance: Appearance;
};

export const WorkplaceTab: React.FC<Props> = ({ isSelected, appearance }) => {
  const localizations = useStrings({
    WorkplaceLabel,
  });

  const classes = useStyles(appearance)();
  return (
    <Tab
      aria-label={localizations.WorkplaceLabel()}
      value={PromptTabs.WorkplacePrompts}
      data-testid={WorkplaceTabTestId}
      className={isSelected ? classes.selected : classes.tab}
    >
      <Text className={isSelected ? classes.selectedText : classes.text}>
        {localizations.WorkplaceLabel()}
      </Text>
    </Tab>
  );
};
